<ngx-contentful-rich-text
  *ngIf="document"
  [document]="document"
  [nodeRenderers]="nodeRenderers">
</ngx-contentful-rich-text>